import React from 'react';
import Paper from '@mui/material/Paper';
import { DashboardIcon, DashboardIconType } from './DashboardIcon';

type MetricCardProps = {
  color: string;
  delta?: string;
  icon: DashboardIconType;
  label: string;
  value: string;
};

export function MetricCard({ color, delta, icon, label, value }: MetricCardProps) {
  return (
    <Paper className="stat-card" component="article" elevation={0}>
      <div className="stat-top">
        <span className={`stat-icon ${color}`}>
          <DashboardIcon type={icon} />
        </span>
        {delta ? (
          <span className="stat-delta up">
            <DashboardIcon type="arrow-up" size={12} />
            {delta}
          </span>
        ) : null}
      </div>
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </Paper>
  );
}
